import axios from 'axios'
import store from '../state/store'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'
// import getSavedState from '@utils/get-state.js'

export default function getPageAccessControl(pageId, append) {
  setDefaultAuthHeaders(store.state)
  let url = `${appConfig.apiEndPoint}${endpoint.adminApiPath.getPageACL}/${pageId}`
  if(!append)
    ArrayPageACL = []

  return axios
    .get(url, {
      headers: setHeaders(),
    })
    .then((response) => {
      if(response && response.data && Array.isArray(response.data) && response.data.length)
      {
        response.data.forEach(acl => {
          acl.readOnly.forEach(r => {
            if(ArrayPageACL
              .findIndex(k => k.name === r) === -1)
              ArrayPageACL
              .push({ name: r, permission: PERMISSIONS.READ })
          })

          acl.show.forEach(r => {
            if(ArrayPageACL
              .findIndex(k => k.name === r) === -1)
              ArrayPageACL
              .push({ name: r, permission: PERMISSIONS.WRITE })
          })
        })

        return ArrayPageACL
      }
    })
    .catch(e => {
      return null
    })
}

export const isReadOnly = function(field) {
  return getFieldPermission(field) === PERMISSIONS.READ
}

export const canShowField = function(field) {
  return getFieldPermission(field) >= PERMISSIONS.READ
}

function getFieldPermission(fieldName) {
  return ((ArrayPageACL.find(i => i.name === fieldName) || {}).permission || 0)
}


export const PERMISSIONS = {
  NONE: 0,
  READ: 1,
  WRITE: 2,
}

// dummy state management
var ArrayPageACL = []

function setHeaders() {
  const path = window.location.href
  const url = path.includes('vod-otpscreen')
  if (url) {
    return {
      'Content-Type': 'application/json',
      Authorization: '',
    }
  } else {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    }
  }
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
